<template>
<div>
  <VueHtml2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="false"
    :preview-modal="true"
    :paginate-elements-by-height="20000"
    filename="hee hee"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    pdf-content-width="730px"
    @beforeDownload="beforeDownload($event)"
    
    @hasStartedGeneration="hasStartedGeneration()"
    @hasGenerated="hasGenerated($event)"
    ref="html2Pdf"
    :htmlToPdfOptions="htmlToPdfOptions"
  >
    <section class="actionplan-pdf" slot="pdf-content" style="width:730px"
      id="actionplanPDF"
      v-if="
        satContent &&
          satContent.Tools &&
          currentAssessment &&
          currentAssessment.Id
      "
    >       
        
        <div class="logo"
          ><img
            src="/assets/images/eLearning-logo-small.svg"
            alt="NSPCC Learning Home"
        /></div>  
       

        <h1 class="page-title">{{ currentAssessment.Name }}</h1>
        <div class="row">
          <div class="col-12">
            <div
              class="body"
              v-html="currentAssessment.ActionPlanIntroduction"
            ></div>
          </div>
        </div>
        <div class="my-5">
          <h4 class="title">Action plan info</h4>
          <hr class="solid" />
          <div class="form-row">
            <div class="col-12 col-md-6 col-lg-3">
              <div class="name">Organisation name</div>
              <div class="body">{{ this.user.OrganisationName ? this.user.OrganisationName : "" }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="name">Contact name</div>
              <div class="body">
                {{
                  (this.user.FirstName ? this.user.FirstName : "") +
                  " " +
                  (this.user.LastName ? this.user.LastName : "")
                }}
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="name">Created on</div>
              <div class="body">{{ this.savedAssessmentDateCreated }}</div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <div class="name">Updated on</div>
              <div class="body">{{ this.dateUpdated }}</div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="col-6">
            <h4 class="title sub-title">Action plan overview</h4>
          </div>
          <div class="col-6">
            <div class="name float-md-right">
              {{ currentAssessment.Standards.length }} Standard{{
                currentAssessment.Standards.length === 1 ? "" : "s"
              }}
            </div>
          </div>
        </div>

        
          <div
            class="list-group mb-5"
            v-for="(standard, i) in currentAssessment.Standards"
            :key="standard.Id"
          >
            <ActionPlanPDFStandard :standard="standard" :standardNumber="i + 1" />
          </div>        
      
    </section>
  </VueHtml2pdf>
</div>
  
</template>

<script>
import { mapState, mapActions } from "vuex";
import { GET_SATCONTENTACTION } from "../store/mutation-types";
import { privateRouter } from "../router";
import moment from "moment";
import ActionPlanPDFStandard from "@/components/actionplan-pdf-standard";
import VueHtml2pdf from "@/components/pdf-export";
/* import html2canvas from 'html2canvas'; */

export default {
  name: "ActionPlanPDF",
  components: {
    ActionPlanPDFStandard,
    VueHtml2pdf
  },
  data() {
    return {
      htmlToPdfOptions: {
        margin: [5, -5, 5, 0],
        html2canvas: {
          scale: 1,
          useCORS: false,
          //x: 380,
          enableLinks: true
          /* width: 700 */
        },
      }
    };
  },
  props: {
    satId: {
      type: Number,
      default: () => 0
    }
  },
  async created() {
    await this.loadSatContent();
  },
  methods: {
    // this beforeDownload does nothing at the moment, not working with the html2canvas modal
    async beforeDownload ({ html2pdf, options, pdfContent }) {
        await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages()
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i)
                pdf.setFontSize(10)
                pdf.setTextColor(125)
                pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.87), 10)
            } 
        });
        //console.log(html2pdf);
        /* html2canvas(pdfContent).then(function(canvas) {
            document.body.appendChild(canvas);
        }); */
    },
    /* async hasDownloaded(pdfContent){
      console.log('hasDownloaded');
      console.log(pdfContent)
      pdfContent.print();
    }, */
    ...mapActions([GET_SATCONTENTACTION]),
    async loadSatContent() {
      /* if(!this.satContent || !this.satContent.Tools){ // get satContent from API if not in the store (e.g. hitting this route before overview page)
                    await this.getSatContentAction();
                }  */

      // always get satContent from DB for action plan
      await this.getSatContentAction();
    },
    routeToOverview() {
      privateRouter.push({
        name: "SATs",
        query: {
          activeTab: 1
        }
      });
    },
    backToTop() {
      window.scrollTo(0, 0);
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },    
  },
  computed: {
    ...mapState({
      satContent: state => state.satContent,
      user: state => state.users.user
    }),
    currentAssessment: {
      get() {
        return this.satContent && this.satContent.Tools && this.satId
          ? this.satContent.Tools.filter(tool => {
              return tool.Id === this.satId;
            })[0]
          : {};
      },
      set() {}
    },
    dateUpdated() {
      // all responses are updated when saved, so just get the UpdatedDate of the first response (if it has ever been saved)
      return this.currentAssessment.Standards[0].Sections[0].Questions[0]
        .SAT_SavedResponses.Id
        ? // we have a saved response
          moment(
            this.currentAssessment.Standards[0].Sections[0].Questions[0]
              .SAT_SavedResponses.DateUpdated
          ).format("LL")
        : // response Id is null so assessment has never been saved
          "Assessment not saved";
    },
    savedAssessmentDateCreated() {
      return this.currentAssessment.SavedAssessmentDateCreated
        ? moment(this.currentAssessment.SavedAssessmentDateCreated).format("LL")
        : "Assessment not saved";
    }
  }
};
</script>

<style lang="sass" scoped></style>
